var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertTriangleYellow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_0a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD45",
    d: "M14.6399 12.3766 8.982 2.7078q-.3719-.5577-.9828-.5578t-.9828.5578l-5.6578 9.6688q-.3187.5844 0 1.1156.2922.5313.9828.5578H13.657q.6907-.0265.9829-.5578.3186-.5312 0-1.1156M7.3617 5.7625q.0532-.5843.6375-.6375.5844.0532.6375.6375v3.4q-.053.5844-.611.6375-.2655 0-.4515-.1859-.2125-.186-.2125-.4516zm.6375 6.5875q-.3453 0-.5843-.2391-.2391-.239-.2391-.5843 0-.3719.239-.6109.2391-.2391.5844-.2391t.5844.2391.239.6109q0 .3453-.239.5843-.2391.2391-.5844.2391"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_0a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertTriangleYellow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert-triangle-yellow.d0c7039ba10bcedd217f45379e2a0a6d.svg";